var render = function (_h,_vm) {var _c=_vm._c;return _c('font-awesome-icon',{staticClass:"icon-book",class:{
    'icon-book-active': _vm.props.active
  },attrs:{"icon":"book"}})}
var staticRenderFns = []

export { render, staticRenderFns }